/**
 * Sets a value in local storage.
 * @param {string} key - The key under which the value is stored.
 * @param {any} value - The value to store.
 * @throws Will throw an error if the value cannot be set in local storage.
 */
export function setLocalStorage(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // catch possible errors:
    // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
    throw new Error(`Cannot set ${key} to localStorage`);
  }
}

/**
 * Retrieves a value from local storage.
 * @param {string} key - The key of the value to retrieve.
 * @param {any} initialValue - The initial value to return if the key does not exist or an error occurs.
 * @returns {any} The retrieved value or the initial value if the key does not exist or an error occurs.
 */
export function getLocalStorage(key, initialValue) {
  try {
    const value = window.localStorage.getItem(key);
    return value ? JSON.parse(value) : initialValue;
  } catch {
    // if error, return initial value
    return initialValue;
  }
}
